import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Card, Input, Modal } from 'antd';
import Button from 'antd/es/button';
import PropTypes from 'prop-types';
import {
  Box, ForEach, ShowIf, Text,
} from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import NumberFormat from '../../../shared/components/dataDisplay/NumberFormat';
import { calcularTotal, calcularTotalPorEncargo, sePuedeGuardar } from '../../../../state/selectors/encargos.creador.selectors';
import { guardarEncargos } from '../../../../state/actions/creators/encargos.creador.actioncreator';

class ResumenEncargo extends React.Component {


  constructor(props, context) {
    super(props, context);
    this.state = {
      modalVisible: false,
    }
  }

  render() {
    const {
      total, totalPorEncargo, mostrarGuardado, sePuedeGuardar, encargosCount, guardarEncargos
    } = this.props;
    const { modalVisible } = this.state;
    return (
      <Box>
        <Modal
          width={800}
          visible={modalVisible}
          onCancel={() => this.setState({ modalVisible: false }) }
          footer={(
            <TwoColumnsFlexLayout
              mb="16"
              flexRight={2}
              leftContent={
                <Button style={{ float: 'left' }} onClick={() => this.setState({ modalVisible: false })}>
                  <Text translationId="generico.cancelar" />
                </Button>
              }
              rightContent={
                <Box>
                  <Button onClick={() => this.setState({ modalVisible: false })}>
                    <Text translationId="encargos.guardar_como_presupuesto" />
                  </Button>
                  <Button
                    onClick={() => {
                      guardarEncargos();
                      this.setState({ modalVisible: false });
                    }}
                    type="primary"
                  >
                    <Text translationId="encargos.guardar_como_encargo" />
                  </Button>
                </Box>
              }
            />
          )}
          title={<Text translationId="encargos.guardar_encargo" fontWeight="600" fontSize="16" />}
        >
          <Text mb="8" translationId="generico.enviar_por_email" />
          <Input type="email" />
        </Modal>
        <Card>
          <Text translationId="generico.resumen" fontWeight="semibold" fontSize="16" />
        </Card>
        <Card>
          <TwoColumnsFlexLayout
            leftContent={<Text translationId="generico.total" fontWeight="semibold" />}
            rightContent={
              <NumberFormat fontWeight="semibold" style={{ float: 'right' }} number={total} />
            }
          />
        </Card>
        <ShowIf condition={encargosCount > 0 && totalPorEncargo.length > 0}>
          <Card>
            <ForEach
              items={totalPorEncargo}
              render={({ precio, nombre }) => (
                <TwoColumnsFlexLayout
                  mb="16"
                  leftContent={<Text>{ nombre }</Text>}
                  rightContent={
                    <NumberFormat style={{ float: 'right' }} number={precio} />
                  }
                />
              )}
            />
          </Card>
        </ShowIf>
        <ShowIf condition={mostrarGuardado}>
          <Card>
            <Button
              onClick={() => this.setState({ modalVisible: true })}
              disabled={!sePuedeGuardar}
              style={{ float: 'right' }} type="primary"
            >
              <Text translationId="generico.guardar" />
            </Button>
          </Card>
        </ShowIf>
      </Box>
    );
  }
}

const mapStateToProps = state => ({
  encargosCount: state.encargosCreador.encargos.count,
  total: calcularTotal(state),
  totalPorEncargo: calcularTotalPorEncargo(state),
  sePuedeGuardar: sePuedeGuardar(state),
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    guardarEncargos,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResumenEncargo);

ResumenEncargo.propTypes = {
  encargosCount: PropTypes.any.isRequired,
  mostrarGuardado: PropTypes.bool,
  sePuedeGuardar: PropTypes.bool.isRequired,
  total: PropTypes.any.isRequired,
  totalPorEncargo: PropTypes.any.isRequired
}

ResumenEncargo.defaultProps = {
  encargosCount: 0,
  mostrarGuardado: false
}
